import * as React from 'react';
import { PdsIconRefreshCcw as PdsIconRefreshCcwElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconRefreshCcw = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-refresh-ccw',
  elementClass: PdsIconRefreshCcwElement,
  react: React,
});
